import React, { useState, useEffect } from "react";
import { CustomPicker } from "react-color";
import { Saturation, Hue } from "react-color/lib/components/common";
import { Form } from "semantic-ui-react";
import "../../styles/ui.scss";
import { GlobalConstants } from "../constants/GlobalConstants";
import BCButton from "./BCButton";
import BCFormInput from "./BCFormInput";

const Picker = () => {
  return (
    <div className="color-cursor" />
  );
};

const ColorComponent = ({ ...props }) => {
  return (
    <div className={`color-component ${props.disabled ? "color-picker-disabled" : ""} ${props.type === "saturation" ? "saturation-component" : 
      props.type === "hue" ? "hue-component" : props.type === "input" ? "color-input-component" : null}`}>
      {props.children}
    </div>
  );
};

const ColorPicker = ({ ...props }) => {
  const [isInitial, setInitial] = useState(true);
  const [isHexFocus, setIsHexFocus] = useState(false);
  const [hexInput, setHexInput] = useState(props.hex);

  const handleHexValueChanged = (value) => {
    setIsHexFocus(true);
    if (value && value.length > 7) {
      setHexInput(value.substring(0, value.length - 1));
    }
    else if (value && value.length === 7) {
      setHexInput(value);
      props.setColor(value);
    }
    else if (value && value.length > 0) {
      setHexInput(value);
    }
  };

  const handleHexInputBlur = () => {
    if (hexInput.length !== 7) {
      props.setColor(props.hex);
    }

    setIsHexFocus(false);
  };

  useEffect(() => {
    if (isInitial) {
      props.setColor(props.initialHex);
      setInitial(false);
    }

    if (props.hex) {
      props.setHexValue(props.hex);

    }
  }, [props, props.hex, props.setHexValue, props.initialHex, isInitial]);

  return (
    <div className="color-picker-container">
      <ColorComponent {...props} type={"saturation"}>
        <Saturation {...props} onChange={(color) => props.setColor(color)} pointer={Picker} />
      </ColorComponent>
      <ColorComponent {...props} type={"hue"}>
        <Hue {...props} onChange={(color) => props.setColor(color)} />
      </ColorComponent>
      <ColorComponent {...props} type={"input"}>
        <div className="color-input-container">
          <Form className="primary-form">
            <BCFormInput 
              inputClass="color-input"
              type={GlobalConstants.FormInputTypes.INPUT}
              value={isHexFocus ? hexInput : props.hex}
              handleFormChange={(value) => handleHexValueChanged(value)}
              onBlur={handleHexInputBlur}
            />
          </Form>
          <BCButton 
            brokerColor={props.brokerColor} 
            handleOnClick={props.handleOnClick}
            disabled={props.disabled}
          >
            Update
          </BCButton>
        </div>
      </ColorComponent>
    </div>
  );
};

const BPColorPicker = CustomPicker(ColorPicker);
export default BPColorPicker;